import {Helmet} from "react-helmet-async";
import {Container, Grid} from "@mui/material";
import Footer from "../../../components/Footer";
import ListShops from "./ListShops";

function ShopManagement() {
    return (
        <> <br/>
            <Helmet>
                <title>Quản lý shop</title>
            </Helmet>
            <Container maxWidth="lg">
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="stretch"
                    spacing={3}
                >
                    <Grid item xs={12}>
                        {<ListShops />}
                    </Grid>
                </Grid>
            </Container>
            <Footer />
        </>
    );
}

export default ShopManagement;
